import React, { useState } from "react";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { Select } from "@mui/material";
import SellIcon from "@mui/icons-material/Sell";
import AddIcon from "@mui/icons-material/Add";
const TaskEditModal = ({ open, setOpen }) => {
  const [isLoading, setIsLoading] = useState(false);

  // const [open, setOpen] = useState(false);

  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);
  return (
    <div>
      <Modal open={open} onClose={onCloseModal} center>
        <h1 className="mt-[6px] mb-[20px] font-medium text-[18px]">
          Edit Task
        </h1>
        {/* <!-- Form starts --> */}
        <form>
          <div className="w-[100%]">
            <div className="w-[100%]">
              <label className="font-medium text-[#000000ba] text-[13px] xl:text-[14px]">
                Task Name
              </label>
              <br />
              <input
                type="text"
                className="border-1 mt-1 mb-[10px] p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none"
                required
              />{" "}
              <br />
            </div>
            <div className="flex gap-[8px] billing-form-type">
              <div className="w-[100%]">
                <label className="font-medium text-[#000000ba] text-[13px] xl:text-[14px]">
                  Task Status
                </label>{" "}
                <br />
                <select
                  className="border-1 mt-1 mb-[10px] p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none"
                  required
                >
                  <option value="">Please Select Task Status</option>
                </select>
              </div>
            </div>
            <div className="flex gap-[8px] billing-form-type">
              <div className="w-[50%] billing-type-project">
                <label className="font-medium text-[#000000ba] text-[13px] xl:text-[14px]">
                  Start Date
                </label>{" "}
                <br />
                <input
                  type="date"
                  className="border-1 mt-1 mb-[10px] p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none"
                  required
                />{" "}
                <br />
              </div>
              <div className="w-[50%] billing-type-project">
                <label className="font-medium text-[#000000ba] text-[13px] xl:text-[14px]">
                  End Date
                </label>{" "}
                <br />
                <input
                  type="date"
                  className="border-1 mt-1 mb-[10px] p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none"
                />{" "}
                <br />
              </div>
            </div>
            <div className="flex gap-[8px] billing-form-type">
              <div className="w-[50%] billing-type-project">
                <label className="font-medium text-[#000000ba] text-[13px] xl:text-[14px]">
                  Due Date
                </label>{" "}
                <br />
                <input
                  type="date"
                  className="border-1 mt-1 mb-[10px] p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none"
                />{" "}
                <br />
              </div>
              <div className="w-[50%] billing-type-project">
                <label className="font-medium text-[#000000ba] text-[13px] xl:text-[14px]">
                  Select Project
                </label>{" "}
                <br />
                <select
                  className="border-1 mt-1 mb-[10px] p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none"
                  required
                >
                  <option value="">- Select Project -</option>{" "}
                  {/* Placeholder option */}
                </select>
              </div>
            </div>
            <div className="flex gap-[10px] billing-form-type w-[100%]">
              <div className="w-[50%] billing-type-project">
                <label className="font-medium text-[#000000ba] text-[13px] xl:text-[14px]">
                  Select Department
                </label>{" "}
                <br />
                <select
                  className="border-1 hover:bg-[#fff] mt-1 mr-[0px] mb-[10px] p-[5px] border rounded-md w-full placeholder:font-font-normal text-[#000] text-[12px] xl:text-[14px] focus:outline-none"
                  required
                >
                  <option>Select Department</option>
                </select>
              </div>
              <div className="w-[50%] billing-type-project">
                <label className="font-medium text-[#000000ba] text-[13px] xl:text-[14px]">
                  Task Priority
                </label>{" "}
                <br />
                <select
                  className="border-1 hover:bg-[#fff] mt-1 mr-[0px] mb-[10px] p-[5px] border rounded-md w-full placeholder:font-font-normal text-[#000] text-[12px] xl:text-[14px] focus:outline-none"
                  required
                >
                  <option value="">Select Task Priority</option>{" "}
                  {/* Placeholder option */}
                </select>
              </div>
            </div>
            <div className="">
              <div className="w-[100%]">
                <label className="font-medium text-[#000000ba] text-[13px] xl:text-[14px]">
                  Task Assignee
                </label>{" "}
                <br />
                <Select
                  isMulti
                  placeholder="Select Members..."
                  className="w-full h-[40px]"
                  required
                />
              </div>
              <div className="mt-[10px]">
                <label className="font-medium text-[#000000ba] text-[13px] xl:text-[14px]">
                  Task Description
                </label>
                <br />
                <textarea
                  type="text"
                  className="border-1 mt-1 mb-[10px] p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none"
                  required
                />{" "}
                <br />
              </div>
              <div className="w-[100%]">
                <label className="mb-3 font-medium text-[#000000ba] text-[13px] xl:text-[14px]">
                  <SellIcon className="sell-icon" />
                  Task Tag
                </label>
                <br />
                <input
                  type="text"
                  className="mt-2 mb-[10px] pr-2 focus:outline-none tag-input"
                  placeholder="Tag"
                  required
                />{" "}
                <br />
              </div>
            </div>

            <div>
              <label className="font-medium text-[#000000ba] text-[13px] xl:text-[14px]">
                Attach File
              </label>
              <br />
              <div className="relative">
                <input
                  type="file"
                  className="border-1 mt-1 mb-[10px] p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none"
                />
                <button>
                  <AddIcon className="plus-icon" />
                </button>
              </div>
            </div>

            <div>{/* Dynamically render each div */}</div>
            {/* <DescriptionEditer /> */}

            <div className="flex justify-end items-center gap-[10px] pt-3 pr-[10px] pb-[0] border-t">
              <button className="border-[#27004a] bg-white border rounded-md w-20 h-10 text-[#27004a]">
                Cancel
              </button>

              <button
                className={`allcrm-btn1 ${
                  isLoading == true ? "opacity-50 cursor-not-allowed" : ""
                }`}
              >
                Save{" "}
              </button>
            </div>
          </div>
        </form>
        {/* <!-- Form ends --> */}
      </Modal>
    </div>
  );
};

export default TaskEditModal;
